import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../baseQuery';
import type { CustomEmoji, CustomEmojiUploadResponse, MyCustomEmojisResponse } from 'types/interfaces/message';

export const emojiApi = createApi({
  reducerPath: 'emojiApi',
  baseQuery: baseQuery,
  tagTypes: ['CustomEmoji'],
  endpoints: (builder) => ({
    getCustomEmojis: builder.query<CustomEmoji[], void>({
      query: () => ({
        url: '/emoji/custom',
        method: 'GET',
      }),
      providesTags: ['CustomEmoji'],
    }),

    uploadCustomEmoji: builder.mutation<CustomEmojiUploadResponse, FormData>({
      query: (formData) => ({
        url: '/emoji/custom',
        method: 'POST',
        body: formData,
        requiresAuth: true,
      }),
      invalidatesTags: ['CustomEmoji'],
    }),

    deleteCustomEmoji: builder.mutation<{ success: boolean }, string>({
      query: (slug) => ({
        url: `/emoji/custom/${slug}`,
        method: 'DELETE',
        requiresAuth: true,
      }),
      invalidatesTags: ['CustomEmoji'],
    }),

    getMyCustomEmojis: builder.query<MyCustomEmojisResponse, void>({
      query: () => ({
        url: '/emoji/custom/mine',
        method: 'GET',
        requiresAuth: true,
      }),
      providesTags: ['CustomEmoji'],
    }),

    renameCustomEmoji: builder.mutation<CustomEmoji, { slug: string; name: string }>({
      query: ({ slug, name }) => ({
        url: `/emoji/custom/${slug}`,
        method: 'PUT',
        body: { name },
        requiresAuth: true,
      }),
      invalidatesTags: ['CustomEmoji'],
    }),
  }),
});

export const {
  useGetCustomEmojisQuery,
  useUploadCustomEmojiMutation,
  useDeleteCustomEmojiMutation,
  useGetMyCustomEmojisQuery,
  useRenameCustomEmojiMutation,
} = emojiApi;
